import { render, staticRenderFns } from "./changeDetail.vue?vue&type=template&id=3120bff6&scoped=true&"
import script from "./changeDetail.vue?vue&type=script&lang=js&"
export * from "./changeDetail.vue?vue&type=script&lang=js&"
import style0 from "./changeDetail.vue?vue&type=style&index=0&id=3120bff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120bff6",
  null
  
)

export default component.exports